// Copyright (c) 2026 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap, withLatestFrom } from "rxjs/operators"
import * as Actions from "../actions"
import { WELCOME_VIDEO_STATE_KEY } from "./index"
import { setWelcomeVideoState, dismissWelcomeVideo, updateLastShownAt, WelcomeVideoState } from "../welcome-video/slice"
import { RootState } from "../../../app/store"

export type StorageWriter = (value: Partial<WelcomeVideoState>) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(WELCOME_VIDEO_STATE_KEY, JSON.stringify(value))
}

export const persistWelcomeVideoState = (persist: StorageWriter) =>
  (action$: Observable<Action>, state$: Observable<RootState>): Observable<Action> =>
    action$.pipe(
      filter(action =>
        setWelcomeVideoState.match(action) ||
        dismissWelcomeVideo.match(action) ||
        updateLastShownAt.match(action)
      ),
      withLatestFrom(state$),
      mergeMap(([_action, state]) => of(state).pipe(
        tap(() => {
          // Persist the state including dismissed flag
          const { lastShownAt, dismissed } = state.welcomeVideo
          persist({ lastShownAt, dismissed })
        }),
        map(_ => Actions.welcomeVideoStatePersisted()),
        catchError(_ => of(Actions.welcomeVideoStatePersistFailed())),
      )),
    )

export default persistWelcomeVideoState(persist)
